import mixpanel from 'mixpanel-browser';

const mp_active = import.meta.env.VITE_APP_MIXPANEL_PROJECT_TOKEN != undefined;

if (mp_active) {
  mixpanel.init(import.meta.env.VITE_APP_MIXPANEL_PROJECT_TOKEN, {
    api_host: 'https://api-eu.mixpanel.com',
    debug: import.meta.env.DEV,
    track_pageview: 'full-url',
    persistence: 'localStorage',
    record_sessions_percent: 100,
    record_mask_all_text: false,
    record_mask_all_inputs: true,
    record_heatmap_data: true,
    autocapture: {
      capture_text_content: true,
    }
  });
}

type TrackObj = {
  [key: string]: string | number | undefined;
};

const actions = {
  identify: (id: string) => {
    if (mp_active) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (mp_active) mixpanel.alias(id);
  },
  track: (name: string, props?: TrackObj) => {
    if (mp_active) mixpanel.track(name, props);
  },
  people: {
    set: (props: TrackObj) => {
      if (mp_active) mixpanel.people.set(props);
    },
  },
};

export default actions;
